export default __webpack_public_path__ + "static/gantvarsity-sans-regular-f27d669c4ab5888096b09e475177d299.woff2";